module.exports = __webpack_public_path__ + "static/sport/bgi-dialog.30ca8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-dialog.png
// module id = BDdE
// module chunks = 0